/**
 * @generated SignedSource<<2842471765741be524592c426f576bd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ServiceAvailabilityResult = "ADDON_NOT_ACTIVE" | "AVAILABLE" | "FEATURE_NOT_INCLUDED_IN_PLAN" | "NO_CREDITS" | "SHOPIFY_DEV_STORE_NOT_ALLOWED" | "TRIAL_NOT_ALLOWED" | "USE_LIMIT_EXCEEDED";
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "TEST_ORDERS" | "VECTORIZE";
export type useGenerationPreflightAvailabilityQuery$variables = {
  serviceName: ServicesWithCredits;
};
export type useGenerationPreflightAvailabilityQuery$data = {
  readonly serviceAvailabilityStatus: ServiceAvailabilityResult;
};
export type useGenerationPreflightAvailabilityQuery = {
  response: useGenerationPreflightAvailabilityQuery$data;
  variables: useGenerationPreflightAvailabilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceName"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "serviceWithCredits",
        "variableName": "serviceName"
      }
    ],
    "kind": "ScalarField",
    "name": "serviceAvailabilityStatus",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useGenerationPreflightAvailabilityQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useGenerationPreflightAvailabilityQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5a540db6e2e79df9fead82938d292d17",
    "id": null,
    "metadata": {},
    "name": "useGenerationPreflightAvailabilityQuery",
    "operationKind": "query",
    "text": "query useGenerationPreflightAvailabilityQuery(\n  $serviceName: ServicesWithCredits!\n) {\n  serviceAvailabilityStatus(serviceWithCredits: $serviceName)\n}\n"
  }
};
})();

(node as any).hash = "592684b8bac33371c89fc6273d2b47c3";

export default node;
